// extracted by mini-css-extract-plugin
export var discard = "_3d-3";
export var muiTooltipTooltip = "_3d-5";
export var notificationBar = "_3d-2";
export var saveButtonHoverSlotWrapper = "_3d-4";
export var show = "_3d-1";
export var spacer = "_3d-0";